<template>
  <div>
    <div class="checkboxes"
         :class="{visible: visible, collapsable: collapsable, pinned: pinned, dragged: dragged}"
         v-if="items.length"
         :style="{top: top, left: left}"
         @mousedown="onMouseDown($event)"
         @mousemove="onMouseMove($event)"
         ref="movable"
    >
      <div class="panel shadow">
        <h2 class="panel-title" @click.stop="toggleVisible()">{{ label }}
          <i class="material-icons" @click.stop="togglePinned($event)">place</i>
        </h2>

        <div class="panel-content" v-show="visible || !collapsable">
          <div v-for="category in items" :key="key(category)" :class="'md-' + type">
            <input :type="type" :id="key(category)" :value="category.hash"
                   :checked="model.indexOf(category.hash)!==-1"
                   v-on:click.stop="updateValue($event.target.value)"
            >
            <label :for="key(category)">{{ category.name }}</label>
          </div>
        </div>
        <div @click="visible=!visible" class="panel-content result"
             v-show="selectedItems && !visible">
          {{ selectedItems }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'Checkboxes',
    props: ['items', 'model', 'label', 'collapsable', 'prefix', 'type'],
    data () {
      return {
        pinned: false,
        dragged: false,
        visible: false,
        myModel: this.mode,
        top: '40px',
        left: '40px'
      }
    },
    computed: {
      selectedItems () {
        return this.items.filter(item => this.model.indexOf(item.hash) !== -1).map(item => item.name).join(', ')
      }
    },
    mounted () {
      window.document.body.addEventListener('mouseup', this.onMouseUp)
      window.document.body.addEventListener('mousemove', this.onMouseMove)
    },
    beforeDestroy () {
      window.document.body.removeEventListener('mouseup', this.onMouseUp)
      window.document.body.removeEventListener('mousemove', this.onMouseMove)
    },
    methods: {
      onMouseDown (e) {
        if (this.pinned) {
          this.dragged = {
            dy: e.clientY - this.$refs.movable.getBoundingClientRect().y,
            dx: e.clientX - this.$refs.movable.getBoundingClientRect().x
          }
        }
      },
      onMouseUp () {
        this.dragged = false
      },
      onMouseMove ({clientX, clientY}) {
        if (this.dragged) {
          this.top = (clientY - this.dragged.dy) + 'px'
          this.left = (clientX - this.dragged.dx) + 'px'
        }
      },
      toggleVisible () {
        if (!this.pinned) {
          this.visible = !this.visible
        }
      },
      togglePinned ({target}) {
        this.left = this.$refs.movable.offsetLeft + 'px'
        this.pinned = !this.pinned
        this.visible = this.pinned
      },
      key (category) {
        return 'category-' + (this.prefix || '') + category.hash
      },
      updateValue: function (value) {
        if (this.model.indexOf(parseInt(value)) === -1) {
          if (this.type === 'checkbox') {
            this.$emit('updated', [parseInt(value), ...this.model])
          } else {
            this.$emit('updated', [parseInt(value)])
          }
        } else {
          if (this.type === 'checkbox') {
            const newFilter = [...this.model]
            newFilter.splice(this.model.indexOf(parseInt(value)), 1)
            this.$emit('updated', newFilter)
          } else {
            this.$emit('updated', [])
          }
        }
      }
    },
    components: {}
  }
</script>

<style lang="scss">
  @import "../styles/settings";
  @import "../styles/panel";

  .checkboxes {
    h2 {
      padding: .5rem;
      background: $background;
      transition: background 0.2s ease-in-out;
      margin-bottom: 0;
      .material-icons {
        display: none
      }
    }
    &.collapsable {
      h2 {
        cursor: pointer
      }
      .material-icons {
        display: inline-block;
        float: right;
        font-size: 1.5rem;
        color: rgba(0, 0, 0, 0.2);
        transition: color 0.2s ease-in-out;
        &:hover {
          color: rgba(255, 255, 255, .4)
        }
      }
    }
    transition: box-shadow 0.2s ease-in-out;
    &.pinned {
      position: fixed;
      top: 0;
      z-index: 100;
      width: inherit;

      h2 {
        .material-icons {
          color: rgba(255, 255, 255, .6);
          &:hover {
            color: rgba(255, 255, 255, .8)
          }
        }
      }
    }
    &.dragged {
      cursor: move;
      box-shadow: 0 19px 38px rgba(0, 0, 0, 0.30), 0 15px 12px rgba(0, 0, 0, 0.22);
      z-index: 1000;
    }
    .panel {
      font-size: 1rem;
      box-sizing: border-box;
      label {
        font-size: 1rem;
        transition: color 0.2s ease-in-out;
        color: rgba(255, 255, 255, 0.6);
        &:hover {
          color: rgba(255, 255, 255, 0.9);
        }
      }

    }

    $md-checkbox-margin: .8rem 0;
    $md-checkbox-checked-color: $panel-color;
    $md-checkbox-border-color: rgba(255, 255, 255, 0.8);

    $md-checkbox-size: 1rem;
    $md-checkbox-padding: .2rem;

    $md-checkmark-width: 2px;
    $md-checkmark-color: #fff;

    .md-checkbox, .md-radio {
      display: flex;
      position: relative;
      margin: $md-checkbox-margin;

      label {
        cursor: pointer;
        &:before, &:after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
        }

        &:before {
          // box
          width: $md-checkbox-size;
          height: $md-checkbox-size;
          background: $background;
          border: 2px solid $md-checkbox-border-color;
          border-radius: 2px;
          cursor: pointer;
          transition: all .3s;
        }
        &:after {
          // checkmark
        }
      }

      input[type="checkbox"], input[type="radio"] {
        outline: 0;
        margin-right: $md-checkbox-size / 2;
        height: $md-checkbox-size;

        &:checked {
          + label:before {
            background: $md-checkbox-checked-color;
            border: none;
          }
          + label:after {

            $md-checkmark-size: $md-checkbox-size - 2*$md-checkbox-padding;

            transform: rotate(-45deg);

            top: ($md-checkbox-size / 2) - ($md-checkmark-size / 4) - $md-checkbox-size/10;
            left: $md-checkbox-padding;
            width: $md-checkmark-size;
            height: $md-checkmark-size / 2;

            border: $md-checkmark-width solid $md-checkmark-color;
            border-top-style: none;
            border-right-style: none;
          }
        }
      }
    }
    .md-radio {
      label {
        &:before {
          border-radius: 45%
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Checkboxes.vue?45c2aed4